
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPumpOnVertical as ObiPumpOnVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pump-on-vertical.js';
 
 
 

 
 export const ObiPumpOnVertical = createComponent({
   react: React,
   tagName: 'obi-pump-on-vertical',
   elementClass: ObiPumpOnVerticalElement,
   events: {
     
   }
  });
 
 